import type { UserRoles } from 'entities/roles'

export type Organization = {
    id: string
    name: string
    shortName: string
    email: string
    imageKey: string
    status: string
    address: string
    country: string
    place: string
    dateOfEstablishment: string
    contactNumber: string
    createdAt: string
    updatedAt: string
}
export interface OrganizationOptionType {
    id: string
    label: string
    value: string
}
export enum OrganizationStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    ARCHIVED = 'archived',
}

export const OrganizationStatusTranslate = {
    active: OrganizationStatus.ACTIVE,
    inactive: OrganizationStatus.INACTIVE,
    archived: OrganizationStatus.ARCHIVED,
}

export const OrganizationStatusColor = {
    active: 'GREEN',
    inactive: 'RED',
    archived: 'GREY',
}

export type RequestNewOrganization = {
    name: string
    shortName: string
    email: string
    status: string
    address: string
    country: string
    place: string
    dateOfEstablishment: string
    contactNumber: string
}

export type RequestOrganizationGenerateUploadURL = {
    organizationId: string
}

export type RequestOrganizationUploadImage = {
    organizationId: string
    key: string
}

export type RequestOrganizationEditDetail = {
    organizationId: string
    data: Organization
}

export type OrganizationHistory = {
    id: number
    user: object
    actor: {
        id: string
        firstName: string
        lastName: string
        imageKey: string
        showProfilePhoto: boolean
        unisportId?: number
    }
    createdAt: string
    content: string
    type: string
    field: string
    actorId: string
    userId: string
    displayType: string
    displayField: string
}

export type OrganizationRolesAndPermissions = {
    id: string
    firstName: string
    lastName: string
    email: string
    profileStatus: string
    isVerified: boolean
    oib: string
    sex: string
    dateOfBirth: string
    citizenship: string
    placeOfBirth: string
    phoneNumber: string
    shirtSize: string
    imageKey: string
    createdAt: string
    updatedAt: string
    userRoles: UserRoles
}

export type RequestOrganizationRolesAndPermissionsParams = {
    organizationId: string
    page?: number
    limit?: number
    search?: string
}

export type OrganizationFormType = {
    name: string
    shortName: string
    status: { label: string; value: string }
    address: string
    country: { label: string; value: string }
    place: string
    dateOfEstablishment: Date
    email: string
    contactNumber: string
}
